import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';
import { Empty } from 'antd';

const TopClientsByBatchesChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <Empty description="Nenhum dado encontrado" />;
  }

  const chartData = data.map(item => ({
    name: item.nickname || item.clientName,
    value: item.totalBatches,
    color: item.color || '#1890ff'
  }));

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart 
        data={chartData} 
        layout="vertical"
        margin={{ top: 5, right: 30, left: 100, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" />
        <YAxis dataKey="name" type="category" width={90} />
        <Tooltip 
          formatter={(value) => [`${value} lotes`, 'Total']}
        />
        <Legend />
        <Bar dataKey="value" name="Lotes" radius={[0, 8, 8, 0]}>
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default TopClientsByBatchesChart;

